import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';
import { MedicalLeaveCommonFormsBean } from '../../common.types';

type StreetFieldProps = Pick<FormContextValues<MedicalLeaveCommonFormsBean>, 'register'>;

export const StreetField = (props: StreetFieldProps): JSX.Element => {
   return (
      <TextInput
         controller={props.register('address.street', {
            required: true,
            maxLength: 50,
         })}
         label={commonTranslationKeys.street}
         placeholder={commonTranslationKeys.enterStreetName}
         testId={'street'}
         className={'street'}
      />
   );
};
